import styled from 'styled-components';

export const Label = styled.label`
  font-family: Open Sans, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #a6b0cf;
  position: relative;
`;

export const Input = styled.input`
  display: block;
  outline: none;
  border-top: none;
  border-right: none;
  border-left: none;
  font-size: 16px;
  border-bottom: 1px solid #397cf3;
  padding: 10px 0;
  color: black;
  width: 100%;
  margin-right: 10px;

  ::placeholder {
    color: #a6b0cf;
  }
`;
